import { render, staticRenderFns } from "./LGBTQIcon.vue?vue&type=template&id=f4a6293a&lang=pug&"
import script from "./LGBTQIcon.vue?vue&type=script&lang=js&"
export * from "./LGBTQIcon.vue?vue&type=script&lang=js&"
import style0 from "./LGBTQIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports